import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import { Base64 } from "js-base64"
import { generateInventoryAdjustmentsSearchParams } from "../../../../utils"
import { SearchPayload } from "../../../search/SearchPayload"
import SearchService from "../../../search/SearchService"
import { ImportAdjustmentListingSearchPayload } from "../../imports/models"
import { ImportAdjustmentItemsResult } from "../model/adjustmentItemResult"


const OBJECT_TYPE = "inventory-adjustment"
const PREFERENCE_TYPE = "listingItemImportAdjustments"



export class AdjustmentService {
    static transformIntoSearchPayload(payload: ImportAdjustmentListingSearchPayload) {
        const { filters: availableFilters, fields } = SearchService.getTotalsFiltersAndFields({
            typeOfSearch: OBJECT_TYPE
        })

        const transformedPayload = SearchService.getSearchPostData(
            payload.filters, 
            OBJECT_TYPE, 
            availableFilters, 
            undefined, 
            [OBJECT_TYPE], 
            [], 
            fields, 
            payload.keywords
        )

        return {
            ...payload,
            ...transformedPayload,
        }
    }

    static async findAdjustments(payload: ImportAdjustmentListingSearchPayload): Promise<ImportAdjustmentItemsResult> {
        const res = await AppContext.getApiClient().post("/listing/search", AdjustmentService.transformIntoSearchPayload(payload))
        if (res.error) {
            throw new Error(res.error.message)
        } 

        return res as ImportAdjustmentItemsResult
    }

    
    static async findAdjustmentsBySearchPayload(
        paginatedSearch: Partial<SearchPayload>): Promise<ImportAdjustmentItemsResult> {
        const postData = generateInventoryAdjustmentsSearchParams(paginatedSearch)
        const res = await AppContext.getApiClient().post("/listing/search", postData)
        if (res.error) {
            throw new Error(res.error.message)
        } 

        const paymentItemResult = res as ImportAdjustmentItemsResult
        return paymentItemResult
    }

    static async getListingPreferences() {
        const url = "/users/" + AppContext.getUserLoggedIn().id + "/preferences"
        const preferences = await AppContext.getApiClient().get(url)

        return JSON.parse(Base64.decode(preferences.attributes[PREFERENCE_TYPE]))
    }

    static saveListingPreferences(preferences: object) {
        
        const url = "/users/" + AppContext.getUserLoggedIn().id + "/preferences"
        
        return AppContext.getApiClient().patch(url, {
            [PREFERENCE_TYPE]: Base64.encode(JSON.stringify(preferences))
        })
    }
}


// WEBPACK FOOTER //
// ./src/state/inventory/adjustments/service/adjustmentservice.ts